/**
 * Two letters for an avatar: first and last word. ONE home for the card and
 * #/profile — rule 11. Eight other copies remain in routes and components,
 * with small differences (a null name, a fallback glyph); folding them in is
 * a tidy-up of its own and not part of the card.
 */
export function initialsOf(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase()
}
